import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

// components
import { BodyMedium, BodySmall } from '@styled';

// functionality
import { CartItemMembershipContext } from './CartItemMembershipProvider';
import { formatMoney } from '@general/helpers/currency.helpers';
import colors from '@general/colors';
import useMemberDuesEligibilityFromAPI from '@hooks/apiLegacy/useMemberDuesEligibilityFromAPI';
import useMembershipDuesYears from '@hooks/useCartDuesYears';

const FullPriceTextStyled = styled(BodyMedium)`
    color: ${colors.mediumGray};
    margin-right: 10px;
    text-decoration: line-through;
`;

const CartItemMembershipPrices = ({ locale }) => {
    // -----------------------------
    // State
    // -----------------------------

    const [fullPrice, setFullPrice] = useState();

    // -----------------------------
    // Hooks
    // -----------------------------

    const { membershipDataForMember, membershipCartItem } = useContext(CartItemMembershipContext);
    const { memberDuesEligibility } = useMemberDuesEligibilityFromAPI({ id: membershipDataForMember.memberId });
    const { oneOrThreeYears } = useMembershipDuesYears({
        memberId: membershipDataForMember.memberId,
        duesProductId: membershipCartItem.product_id,
    });

    // -----------------------------
    // Effects
    // -----------------------------

    useEffect(() => {
        if (!membershipDataForMember || !memberDuesEligibility || !oneOrThreeYears) {
            return;
        }

        const oneYearDues = memberDuesEligibility.dues.find(dues => dues.years === 1);

        if (oneOrThreeYears === 1) {
            setFullPrice(oneYearDues.price);
        } else if (oneOrThreeYears === 3) {
            setFullPrice(oneYearDues.price * 3);
        }
    }, [membershipDataForMember, membershipCartItem, memberDuesEligibility, oneOrThreeYears]);

    // -----------------------------
    // Render
    // -----------------------------

    if (!fullPrice) {
        return null;
    }

    const isDiscounted = fullPrice && fullPrice !== membershipCartItem.price;

    return (
        <div>
            <div className="flex">
                {isDiscounted && <FullPriceTextStyled>{formatMoney(fullPrice, locale)}</FullPriceTextStyled>}
                <BodyMedium>{formatMoney(membershipCartItem.price, locale)}</BodyMedium>
            </div>
        </div>
    );
};

CartItemMembershipPrices.propTypes = {
    eventDataForMember: PropTypes.shape({
        code: PropTypes.string,
        memberId: PropTypes.number,
        name: PropTypes.string,
        sessions: PropTypes.arrayOf(
            PropTypes.shape({
                //
            })
        ),
    }),
    locale: PropTypes.string,
};

export default CartItemMembershipPrices;
